// @ts-nocheck
import { forwardRef } from 'react';
import { TextInput, PasswordInput, TextInputProps, PasswordInputProps } from '@/components/ui/inputs';

// Mobile-optimized input styling
const mobileInputStyles = {
  input: {
    borderRadius: 12,
    padding: '16px 20px',
    fontSize: 16, // Prevents zoom on iOS
    minHeight: 56, // Larger tap target
  },
  label: {
    fontSize: 14,
    fontWeight: 500,
    marginBottom: 8,
  },
};

// Mobile-styled TextInput
export const MobileTextInput = forwardRef<HTMLInputElement, TextInputProps>((props, ref) => {
  return (
    <TextInput
      ref={ref}
      {...props}
      styles={(theme) => ({
        ...mobileInputStyles,
        ...(props.styles || {}),
      })}
    />
  );
});

MobileTextInput.displayName = 'MobileTextInput';

// Mobile-styled PasswordInput
export const MobilePasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>((props, ref) => {
  return (
    <PasswordInput
      ref={ref}
      {...props}
      styles={(theme) => ({
        ...mobileInputStyles,
        ...(props.styles || {}),
      })}
    />
  );
});

MobilePasswordInput.displayName = 'MobilePasswordInput';

// Default export for convenience
export default {
  TextInput: MobileTextInput,
  PasswordInput: MobilePasswordInput,
};
